// Palette
import { red } from '@mui/material/colors';

export default {
  root: {
    color: '#FFF',
    fontSize: '16px',
  }
};
